let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9H9aT")).then(() => parcelRequire('d80Tb'));